import * as React from "react";
const SvgFiRrScythe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scythe_svg__a)">
      <path
        fill="#062147"
        d="M23.483 1.041A2.57 2.57 0 0 0 21.406 0h-5.561C9.722 0 4.515 2.496.372 7.419A1.55 1.55 0 0 0 .28 9.321a1.555 1.555 0 0 0 1.812.587q.436-.156.94-.345C4.803 8.903 7.224 8 9.744 8h10.674l-1.487 5H13a1 1 0 1 0 0 2h5.335l-2.294 7.715a1.002 1.002 0 0 0 1.918.571l5.934-19.958a2.57 2.57 0 0 0-.41-2.287m-1.51 1.718L21.012 6H9.74c-2.522 0-4.844.749-6.665 1.414C6.612 3.82 10.9 2 15.845 2h5.56c.26 0 .409.149.476.238a.58.58 0 0 1 .093.521"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scythe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScythe;
